/** @jsx h */
/* global H */
import { h, render } from 'preact'
import memoize from 'fast-memoize'
import VenueIcon from '../VenueIcon'

export default class ClusterTheme {
  constructor (pixelratio) {
    this.pixelratio = pixelratio
    this.drawCluster = memoize(drawCluster)
  }

  getCluster (size) {
    if (size < 10) {
      return [
        this.drawCluster(this.pixelratio, 28, '70,70,70'),
        { x: 11, y: 18 }
      ]
    }
    if (size < 25) {
      return [
        this.drawCluster(this.pixelratio, 38, '70,70,70'),
        { x: 13, y: 23 }
      ]
    }
    if (size < 50) {
      return [
        this.drawCluster(this.pixelratio, 38, '70,70,70'),
        { x: 13, y: 23 }
      ]
    }
    if (size < 100) {
      return [
        this.drawCluster(this.pixelratio, 38, '70,70,70'),
        { x: 13, y: 23 }
      ]
    }
    if (size < 1000) {
      return [
        this.drawCluster(this.pixelratio, 48, '70,70,70'),
        { x: 15, y: 28 }
      ]
    }
    if (size >= 1000) {
      return [
        this.drawCluster(this.pixelratio, 66, '70,70,70'),
        { x: 20, y: 38 }
      ]
    }
  }

  getClusterPresentation (cluster) {
    const size = cluster.xc()
    const [blueprintCanvas, bounds] = this.getCluster(size)
    const canvas = document.createElement('canvas')
    canvas.width = blueprintCanvas.width
    canvas.height = blueprintCanvas.height
    const context = canvas.getContext('2d')
    const fontSize = 11 * this.pixelratio
    const x = bounds.x * this.pixelratio
    const y = bounds.y * this.pixelratio
    context.drawImage(blueprintCanvas, 0, 0)
    context.fillStyle = '#FFFFFF'
    context.font = `bold ${fontSize}px Arial`
    context.fillText(size, x, y)
    const icon = new H.map.Icon(canvas, {
      anchor: {
        x: canvas.width / 2,
        y: canvas.width / 2
      }
    })

    const marker = new H.map.Marker(cluster.getPosition(), {
      icon: icon,
      min: cluster.sc(),
      max: cluster.If()
    })
    marker.setData(cluster)

    return marker
  }

  getNoisePresentation (noisePoint) {
    const domIcon = iconFactory(noisePoint)
    const marker = new H.map.DomMarker(noisePoint.getPosition(), {
      icon: domIcon,
      min: noisePoint.getMinZoom()
    })

    marker.setData({ ...noisePoint.getData(), marker })
    return marker
  }
}

let selected
function iconFactory (noisePoint) {
  let element
  const node = document.createElement('div')
  render(<VenueIcon {...noisePoint.getData()} />, node)

  const domIcon = new H.map.DomIcon(node, {
    onAttach: function (clonedElement, domIcon, domMarker) {
      element = clonedElement
      domMarker.addEventListener('tap', handleTap, { passive: true })
    },
    onDetach: function (clonedElement, domIcon, domMarker) {
      element = null
      domMarker.removeEventListener('tap', handleTap)
    }
  })

  return domIcon

  function handleTap (event) {
    const marker = event.target
    marker.setZIndex(2)

    if (selected) {
      selected.marker.setZIndex(1)
      render(<VenueIcon {...selected.noisePoint.getData()} active={false} />, selected.element, selected.element.firstChild)
    }
    selected = { noisePoint, element, marker }

    render(<VenueIcon {...noisePoint.getData()} active />, element, element.firstChild)
  }
}

function drawCluster (pixelratio, diameter, rgb) {
  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')
  const radius = diameter / 2

  diameter *= pixelratio
  canvas.width = diameter
  canvas.height = diameter
  context.beginPath()
  context.strokeStyle = `rgba(${rgb}, 0.2)`
  context.fillStyle = `rgba(${rgb}, 1)`
  context.arc(radius, radius, radius / 5 * 3, 0, 2 * Math.PI, false)
  context.fill()
  context.lineWidth = radius / 5 * 4
  context.stroke()
  return canvas
}
